// extracted by mini-css-extract-plugin
export var backupIcon = "_mu-1";
export var image = "_mu-0";